const config = {
  DEBUG: process.env.REACT_APP_DEBUG,
  FAKE_TOKEN: process.env.REACT_APP_FAKE_TOKEN,
  BASE_URL: process.env.REACT_APP_BASE_URL,
  API_ENDPOINT: process.env.REACT_APP_API_ENDPOINT,
  CDN_URL: process.env.REACT_APP_CDN_URL,
  WECHAT_WORK_APP_ID: process.env.REACT_APP_WECHAT_WORK_APP_ID || '',
  WECHAT_WORK_AGENT_ID: process.env.REACT_APP_WECHAT_WORK_AGENT_ID || '',
  ALIYUN_OSS_BUKECT: process.env.REACT_APP_ALIYUN_OSS_BUKECT,
  ALIYUN_OSS_PREFIX_DOMAIN: process.env.REACT_APP_ALIYUN_OSS_PREFIX_DOMAIN,
  ALIYUN_OSS_ACCESS_KEY_ID: 'LTAI4FtqvRvkuotQbhMXrKwe',
  ALIYUN_OSS_ACCESS_KEY_SECRET: 'I21wIB7Ik0fMJtxTipkbmdCla1NCqm',
  ALIYUN_OSS_REGION: 'oss-cn-shanghai',
  ALIYUN_OSS_TRANSIT_FOLDER: 'upload',
  ALIYUN_OSS_FINALLY_FOLDER: 'files/upload',
  VERSION: process.env.REACT_APP_VERSION,
};

console.log('CONFIG:', config);

export { config };



// WEBPACK FOOTER //
// ./src/config.ts